export function getRole() {
  return localStorage.getItem("role") || "fpo_admin";
}

export function getOwnFpoId() {
  return localStorage.getItem("fpo_id") || "1";
}

export function getSelectedFpoId() {
  const role = getRole();

  if (role === "super_admin") {
    return localStorage.getItem("selected_fpo_id") || getOwnFpoId() || "1";
  }

  return getOwnFpoId() || "1";
}

export function authHeaders(extraHeaders = {}) {
  const token = localStorage.getItem("token");
  const role = getRole();

  const headers = {
    Authorization: token,
    ...extraHeaders,
  };

  if (role === "super_admin") {
    headers["X-FPO-ID"] = getSelectedFpoId();
  }

  return headers;
}